import { PageHero } from '@/components/PageHero'
import { company } from '@/config/company'
import { legalWarning } from '@/config/content'
import styles from './ContentPage.module.css'

export function LegalPage() {
  return (
    <>
      <PageHero title="Yasal Uyarı" subtitle={company.legalName} />
      <section className={styles.section}>
        <div className={`container ${styles.prose}`}>
          <p className={styles.brandName}>{company.name}</p>
          <h2 className={styles.legalTitle}>{company.legalName}</h2>
          {legalWarning.map((p) => (
            <p key={p.slice(0, 48)}>{p}</p>
          ))}
        </div>
      </section>
    </>
  )
}
